import { render, staticRenderFns } from "./turnTable.vue?vue&type=template&id=4c23f65f&scoped=true"
import script from "./turnTable.vue?vue&type=script&lang=js"
export * from "./turnTable.vue?vue&type=script&lang=js"
import style0 from "./turnTable.vue?vue&type=style&index=0&id=4c23f65f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c23f65f",
  null
  
)

export default component.exports